<template>
    <div class="api-root-page">
        <div class="head" :style="{'height' : routerHeadHeight +'px' }" style="position:relative">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane label="基本使用说明" name="usage-desc"></el-tab-pane>
                <el-tab-pane label="api接口（分组）" name="tree-list"></el-tab-pane>
                <el-tab-pane label="api接口（全部）" name="conf-list"></el-tab-pane>
            </el-tabs>
            <div style="position:absolute;top:0;right:0;">
                <el-button size="mini" @click="openOpenPageList();">可授权访问的页面</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button size="mini" @click="openSysJointPage();">平台/商户 对接点</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button size="mini" @click="openFeeShareCalcDlg();">费用分摊/误差平衡</el-button>
            </div>
        </div>
        <div class="body" :style="{'height' : routerBodyHeight +'px' }" style="overflow-y: auto;">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, } from '../../app.vues'
    import { showFeeShareCalcDlg } from '../comn/dialog'

    export default {
        name: 'api-root-page',
        desc: 'api根页面',
        props: {},
        data: function () {
            return {
                routerHeadHeight: 60,
                routerBodyHeight: 400,
                //
                activeName: 'tree-list',
                //
                targetUrls: {
                    'usage-desc': '/api/usage/desc',
                    'tree-list': '/api/tree/list',
                    'conf-list': '/api/conf/list'
                }
            }
        },
        mounted() {
            this.reSize()
            //
            this.showViewForTab(this.activeName)
        },
        methods: {
            reSize() {
                this.routerBodyHeight = $(window).height() - this.routerHeadHeight - 20
            },
            showViewForTab(tabName) {
                let pathUrl = this.targetUrls[tabName]
                //
                let router = this.$router
                router.push(pathUrl)
            },
            handleTabClick(tab, event) {
                //console.log(tab.name);
                this.showViewForTab(tab.name)
            },
            openOpenPageList() {
                Utils.setPageUrl(getAppUrl('/open-page-list'), '_blank')
            },
            openSysJointPage() {
                Utils.setPageUrl(getAppUrl('/api-joint'), '_blank')
            },
            openFeeShareCalcDlg() {
                let shareName = '物流费用'; //分摊费用名称
                let useForUpdate = false; //是否要要用结果进行过更新，如果用于更新则必须传递 shareAmount 和 shareItems，并且不能新增分摊条目
                let shareAmount = 1000; //分摊费用总额
                let shareItems = [{
                    'ukId': 'ZC001',
                    'name': '中央空调',
                    'quantity': 1,
                    'refPrice': 50000
                }, {
                    'ukId': 'ZC002',
                    'name': '冰箱',
                    'quantity': 3,
                    'refPrice': 1000
                }, {
                    'ukId': 'ZC003',
                    'name': '货架',
                    'quantity': 4,
                    'refPrice': 150
                }];

                let dlgConfig = {
                    shareName: shareName,
                    useForUpdate: useForUpdate,
                    shareAmount: shareAmount,
                    shareItems: shareItems,
                    //ukIdTitle: '资产编码',
                    //ukIdWidth: 100,
                    //nameTitle: '资产名称'
                };
                //
                showFeeShareCalcDlg(dlgConfig, function (result) {
                    //useForUpdate == true 可能得到此 结果 回调
                    console.log(result);
                    //TODO 根据结果更新原来的分摊信息
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/apiDoc/ApiRootPage.vue